// src/pages/Login.jsx

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  TextField,
  Typography,
  Link,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useAuth } from "../context/AuthContext";
import "../styles/login.css";

const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  // Estados del formulario
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // Si ya está autenticado, redirigir al dashboard
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  /**
   * 🎯 Manejo del submit del formulario
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Validación básica en el frontend
      if (!email || !password) {
        setError("Por favor completa todos los campos");
        setLoading(false);
        return;
      }

      // Intentar login usando el contexto de autenticación
      const result = await login(email, password);

      if (result.success) {
        // Login exitoso - el redirect se hace automáticamente con el useEffect
        console.log("Login exitoso:", result.user);
      } else {
        // Mostrar error
        setError(result.error || "Error al iniciar sesión");
      }
    } catch (err) {
      console.error("Error en login:", err);
      setError("Error inesperado. Por favor intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="login-container">
      <Box className="login-card">
        <Typography variant="h5" className="login-title">
          Iniciar Sesión
        </Typography>

        <form className="login-form" onSubmit={handleSubmit}>
          {/* Campo de Email */}
          <TextField
            label="Correo electrónico"
            type="email"
            fullWidth
            margin="normal"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
            placeholder="tu_email@example.com"
            autoComplete="email"
          />

          {/* Campo de Contraseña */}
          <TextField
            label="Contraseña"
            type="password"
            fullWidth
            margin="normal"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            autoComplete="current-password"
          />

          {/* Mensaje de Error */}
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}

          {/* Botón de Submit */}
          <Button
            type="submit"
            variant="contained"
            color="secondary"
            fullWidth
            className="login-button"
            disabled={loading}
            sx={{ mt: 2 }}
          >
            {loading ? (
              <>
                <CircularProgress size={20} sx={{ mr: 1 }} color="inherit" />
                Iniciando sesión...
              </>
            ) : (
              "Ingresar"
            )}
          </Button>

          {/* Links de navegación */}
          <Box className="login-links">
            <Link href="/recuperar-password" underline="hover">
              ¿Olvidaste tu contraseña?
            </Link>
            <Link href="/registro" underline="hover">
              Crear una cuenta
            </Link>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default Login;
